import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Car, HandCoins, Search, Phone } from "lucide-react";
import { waLink, FEATURES } from "@/lib/company";
import { WaIcon, useWhatsAppText } from "@/lib/whatsapp";

const items = [
  { to: "/fahrzeuge", label: "Fahrzeuge", icon: Car, id: "fahrzeuge" },
  ...(FEATURES.ankauf ? [{ to: "/ankauf", label: "Ankauf", icon: HandCoins, id: "ankauf" }] : []),
  ...(FEATURES.findet ? [{ to: "/fahrzeugsuche", label: "Suche", icon: Search, id: "suche" }] : []),
];
const COLS = { 3: "grid-cols-3", 4: "grid-cols-4", 5: "grid-cols-5" }[items.length + 2];

const cls = ({ isActive }) =>
  `flex flex-col items-center justify-center gap-1 text-[10px] font-semibold transition-colors duration-200 ${isActive ? "text-brand" : "text-dim"}`;

export const MobileNav = () => {
  const text = useWhatsAppText();
  const { pathname } = useLocation();
  if (/^\/fahrzeuge\/[^/]+/.test(pathname) || pathname.startsWith("/admin")) return null;
  return (
    <nav data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 glass border-t border-line shadow-[0_-10px_30px_rgba(0,0,0,0.35)] pb-[env(safe-area-inset-bottom)]">
      <div className={`grid ${COLS} h-16`}>
        {items.map(({ to, label, icon: Icon, id }) => (
          <NavLink key={to} to={to} data-testid={`mobile-nav-${id}`} className={cls}>
            <Icon size={21} strokeWidth={1.8} /> {label}
          </NavLink>
        ))}
        <a href={waLink(text)} target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-whatsapp"
          className="flex flex-col items-center justify-center gap-1 text-[10px] font-semibold text-dim">
          <WaIcon size={20} className="text-[#25D366]" /> WhatsApp
        </a>
        <NavLink to="/kontakt" data-testid="mobile-nav-kontakt" className={cls}>
          <Phone size={21} strokeWidth={1.8} /> Kontakt
        </NavLink>
      </div>
    </nav>
  );
};

export default MobileNav;
